export const STATUS_DB = {
  PENDING_VERIFICATION: 'PENDING_VERIFICATION',
  VERIFIED: 'VERIFIED',
  RELEASED: 'RELEASED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  PAID: 'PAID',
  WAITING_RECIPIENT_ACCEPT: 'WAITING_RECIPIENT_ACCEPT',
  CANCELLED_BY_INITIATOR: 'CANCELLED_BY_INITIATOR',
  REJECTED_BY_RECIPIENT: 'REJECTED_BY_RECIPIENT',
  ACCEPTED_BY_RECIPIENT: 'ACCEPTED_BY_RECIPIENT',
  ACCEPTED_BY_INITIATOR: 'ACCEPTED_BY_INITIATOR',
  CANCELLED_BY_SYSTEM: 'CANCELLED_BY_SYSTEM',
  ESPERANDO_PAGO: 'ESPERANDO_PAGO',
  COTIZACION_VENCIDA: 'COTIZACION_VENCIDA',
  REVISANDO_PAGO: 'REVISANDO_PAGO',
  PAGO_CONFIRMADO: 'PAGO_CONFIRMADO',
  EN_REVISION: 'EN_REVISION',
  TRANSFERENCIA_ENVIADA: 'TRANSFERENCIA_ENVIADA',
  TRANSFERENCIA_EXITOSA: 'TRANSFERENCIA_EXITOSA',
  DEVOLUCION_EN_PROCESO: 'DEVOLUCION_EN_PROCESO',
  DEVUELTO: 'DEVUELTO',
  ENVIO_ANULADO: 'ENVIO_ANULADO',
  DATOS_VERIFICADOS: 'DATOS_VERIFICADOS',
  ENVIO_RECHAZADO: 'ENVIO_RECHAZADO',
  UNDER_COMPLIANCE_REVIEW: 'UNDER_COMPLIANCE_REVIEW',
  DEFAULT: 'DEFAULT',
} as const;

export type StatusDb = (typeof STATUS_DB)[keyof typeof STATUS_DB];

export const PillColor = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'info',
} as const;

export type PillColor = (typeof PillColor)[keyof typeof PillColor];
